import {
  RebateOverview,
  RebateOverviewFetcherQuery,
  RebateOverviewFetcherQueryVariables,
} from "@/gql/graphql";
import { gql, useLazyQuery } from "@apollo/client";

export const rebateOverviewQuery = gql`
  query RebateOverviewFetcher($filter: RebateOverviewFilter!) {
    rebates {
      rebateOverview(filter: $filter) {
        rebateAgreementId
        rebateAgreementNumber
        criteriaIds
        goalIds
        rebateAgreement {
          name
          rebateAgreementNumber
          currencyCode
        }
        criterias {
          id
          name
          description
          rebateModelCode
        }
        period
        displayedTarget
        achieved
        customers {
          custIndex
        }
        rebateTermCode
        reservedAmount
        creditNoteBookingNumbers
        sellerIds
        isTopLevel
        goals {
          id
          criteriaId
          validFrom
          validTo
          period
          year
          statusCode
          amountPaid
          datePaid
          rebateRate
          expectedVolume
          targetValue
          amountReversed
          authorizedBy
        }
      }
    }
  }
`;

export const useRebateOverview = () => {
  const [loadRebateOverview, { loading, error, data }] = useLazyQuery<
    RebateOverviewFetcherQuery,
    RebateOverviewFetcherQueryVariables
  >(rebateOverviewQuery);

  return {
    loadRebateOverview,
    loading,
    error,
    rebateOverview: (data?.rebates.rebateOverview ?? []) as RebateOverview[],
  };
};
